import { Validators } from '@angular/forms';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Policy number format:
 *  - Uppercase letters and digits only (e.g. ABC123)
 *  - OR uppercase letters/digits with exactly one hyphen separating two alphanumeric segments (e.g. FLEX0000000-00)
 *  - No leading/trailing hyphens, no consecutive hyphens, no other special characters
 */
export const POLICY_NUMBER_PATTERN = /^[A-Z0-9]+(-[A-Z0-9]+)?$/;

export class CustomValidators {
  static phone = Validators.pattern('[0-9-+() ]*');
}

export function validEmailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const email = control.value;
    if (!email) {
      return null;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = emailPattern.test(email);
    return isValid ? null : { invalidEmail: { value: email } };
  };
}

  export function maxNumberValidator(maxNumber: number = 100): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const value = control.value;
      if (value && value > maxNumber) {
        return { maxNumber: { value: control.value } };
      }
      return null;
    };
  }
